import React, {useEffect, useState} from 'react';
import {Link, useLocation, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import ContratCreation from "../../../components/Admin/Contrat/ContratCreation";
import styles from "../Admin.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBuilding, faCalendar, faCalendarAlt, faCertificate,
    faEdit,
    faExternalLink,
    faLocationDot, faMaximize,
    faSquareCheck, faUsersViewfinder,
    faXmark
} from "@fortawesome/free-solid-svg-icons";
import {ReactComponent as AjouterIcone} from "../../../icons/ajouter.svg";
import Routing from "../../../services/routing";
import {faMaxcdn} from "@fortawesome/free-brands-svg-icons";
import DateService from "../../../services/DateService";
import ErrorPage from "../../Erreurs/ErrorPage";

function AdminContratPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const {entrepriseId, contratId} = useParams();
    const [entreprise, setEntreprise] = useState({});
    const [contrat, setContrat] = useState({});
    const { updateBreadcrumb, updateDynamicBreadcrumb } = useBreadcrumb();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    const getContrat = async () => {
        try {
            const response = await AxiosConfig.get(`/admin/entreprises/${entrepriseId}/contrats/${contratId}`);

            setMyApiData(response.data.myContrat);
            setEntreprise(response.data.myEntreprise);
            setContrat(response.data.myContrat);
        } catch (error) {
            console.error('error', error);
        }
    };

    useEffect(() => {
        getContrat();
    }, [user]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ entreprise, contrat }));
    }, [ entreprise, contrat ]);

    useEffect(() => {
        console.log("contrat", contrat);
    }, [ contrat ]);

    if (!entreprise || Object.keys(entreprise).length === 0
        || !contrat || Object.keys(contrat).length === 0
    ) {
        return <ErrorPage title={"Page inaccessible"}/>;
    }

    const fetchSetActif = async (url, data) => {
        try {
            const response = await AxiosConfig.post(url, data);
            setContrat(response.data.myContrat);
        } catch (error) {
            console.error('error', error);
        }
    }

    const putActifOpenModal = () => {
        showModal('confirm', {
            message: "Voulez-vous vraiment supprimer cette entreprise ?",
            onConfirm: () => {
                fetchSetActif(`/admin/entreprises/${entrepriseId}/actif`, {"actif": contrat.actif});
                handleSuccess("Enregistré");
            }
        });
    }

    return (
        <div className="content">
            <TitleMain text="Contrat"/>
            {mode === 'creation' ?
                <ContratCreation entreprise={entreprise} contrat={contrat} onSaved={getContrat}/> :

                <div className={styles.viewBloc} style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                    <div className={styles.headerBtnsVue}>
                        <button onClick={putActifOpenModal}>{contrat.actif ? <><FontAwesomeIcon
                            icon={faXmark}/>Supprimer</> : <><FontAwesomeIcon
                            icon={faSquareCheck}/>Restaurer</>}</button>
                        <Link to={Routing.routes.adminCreation}><FontAwesomeIcon
                            icon={faEdit}/>Modifier</Link>
                    </div>

                    <div>
                        {contrat?.user_created_by?.id &&
                        <p className={styles.creerParLeBloc}>
                            Crée par
                            <Link to={Routing.generate({ route: Routing.routes.adminUtilisateur, params: { utilisateurId: contrat?.user_created_by?.id } })} style={{ margin: "0 2px"}}>
                                {contrat?.user_created_by?.prenom} {contrat?.user_created_by?.nom}
                            </Link>
                            le {DateService.formatDate(contrat.date_created)}
                            {contrat.date_updated ?
                                <> et mis à jour par
                                    <Link to={Routing.generate({ route: Routing.routes.adminUtilisateur, params: { utilisateurId: contrat?.user_updated_by?.id } })} style={{ margin: "0 2px"}}>
                                        {contrat?.user_updated_by?.prenom} {contrat?.user_updated_by?.nom}
                                    </Link>
                                    le {DateService.formatDate(contrat.date_updated)}
                                </> : null}
                        </p>}

                        {contrat.label && <h3 style={{ margin: "0 0 12px 0" }}>{contrat.label}</h3>}

                        {entreprise && entreprise.id ?
                            <div style={{marginBottom: "10px"}}>
                                {/* Entreprise */}
                                <div>
                                    <FontAwesomeIcon icon={faBuilding}/>
                                    <span style={{marginLeft: "4px"}}>
                                        <Link to={Routing.generate({
                                            route: Routing.routes.adminEntreprise,
                                            params: { entrepriseId: entreprise.id }
                                        })}>{entreprise.nom}</Link>
                                    </span>
                                </div>
                                <div>
                                    <FontAwesomeIcon icon={faLocationDot}/>
                                    <span style={{marginLeft: "4px"}}>
                                        <a target={"_blank"} href={`https://www.google.com/maps/place/${encodeURI(entreprise.addr + " " + entreprise.ville + " " + entreprise.cp + " " + entreprise.pays)}`}>
                                            {entreprise.addr}, {entreprise.ville} {entreprise.cp} - {entreprise.pays}
                                        </a>
                                    </span>
                                </div>
                            </div>
                            : null
                        }

                        <p>
                            <FontAwesomeIcon icon={faCalendarAlt}/>
                            <span style={{marginLeft: "4px"}}>Du {
                                DateService.formatDateJoli(contrat.date_start)
                            } au {DateService.formatDateJoli(contrat.date_end)}</span>
                        </p>

                        <p>
                            <FontAwesomeIcon icon={faUsersViewfinder}/>
                            <span style={{marginLeft: "4px"}}>Nombre de participations max par semaine : {contrat.max_participations ?? " Pas de limite"}</span>
                        </p>

                    </div>

                    <div className={styles.navLink}>
                        <Link to={Routing.generate({
                            route: Routing.routes.adminActivites,
                            params: { entrepriseId, contratId },
                            queryParams: { mode: 'creation' }
                        })}>
                            <AjouterIcone/>
                            Ajouter une activité
                        </Link>

                        <Link to={Routing.generate({
                            route: Routing.routes.adminActivites,
                            params: { entrepriseId, contratId }
                        })}>
                            <FontAwesomeIcon icon={faExternalLink}/>
                            Voir les activités
                        </Link>
                    </div>
                </div>
            }

        </div>
    )
}

export default AdminContratPage;
